import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-A3-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 222.29 42.28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-A3-logo_svg__cls-1,.svg-A3-logo_svg__cls-2{fill:#00217a;fill-rule:evenodd}.svg-A3-logo_svg__cls-2{fill:#94aacb}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M214.15 21.14h8.14c-4.31-2.08-7.82-5.45-9.98-9.58C208.74 4.73 201.86.83 192.91 0l.21.6c6.19 2.38 10.48 6.16 12.96 11.5 1.75 3.7 4.56 6.83 8.06 9.04Z",
      class: "svg-A3-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M214.15 21.14h8.14c-4.31 2.08-7.82 5.45-9.98 9.58-3.57 6.83-10.45 10.73-19.4 11.56l.21-.59c6.19-2.39 10.48-6.16 12.96-11.5 1.75-3.7 4.56-6.83 8.06-9.05Z",
      class: "svg-A3-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M192.91 6.86c1.48 5.24 3.47 9.59 5.22 11.71.9 1.11 2.08 2 3.44 2.57h6.42c-3.03-1.29-5.46-3.62-6.8-6.51-1.6-3.5-4.58-6.3-8.28-7.77Z",
      class: "svg-A3-logo_svg__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M192.91 35.42c1.48-5.24 3.47-9.59 5.22-11.71.9-1.11 2.08-2 3.44-2.57h6.42c-3.03 1.29-5.46 3.61-6.8 6.5-1.6 3.5-4.58 6.3-8.28 7.77ZM54.99 31.13l.68-3.51H38v-4.43h14.08s.01 0 .01-.01V19.1h-14.1v-4.44h15.87c.39 0 .72-.27.78-.63l.62-3.45H33.78c-.4 0-.73.31-.73.7v20.44h21.22c.35 0 .65-.24.71-.58ZM114.52 31.13l.68-3.51H97.53v-4.43h14.08s.01 0 .01-.01V19.1h-14.1v-4.44h15.87c.39 0 .72-.27.78-.63l.62-3.45H93.31c-.4 0-.73.31-.73.7v20.44h21.22c.35 0 .65-.24.71-.58ZM156.49 16.85l15.53 14.3c.39.36.9.56 1.44.56h3.6V10.57h-4.04c-.43 0-.77.33-.77.74v13.58l-15.01-13.8a2.04 2.04 0 0 0-1.36-.52h-4.33v21.14h4.92l.03-14.86ZM7.55 27.83c.23-.44.69-.71 1.21-.71h11.93l2.12 3.92c.22.41.67.67 1.15.67h4.84L17.7 11.42c-.29-.53-.86-.85-1.48-.85h-4.66L0 31.71h5.43l2.12-3.88Zm6.78-12.38 4.13 7.59h-8.28l4.16-7.59ZM125.85 27.83c.23-.44.69-.71 1.21-.71h11.93l2.12 3.92c.22.41.67.67 1.15.67h4.84L136 11.42c-.29-.53-.86-.85-1.48-.85h-4.66l-11.57 21.14h5.43l2.12-3.88Zm6.78-12.38 4.13 7.59h-8.28l4.15-7.59ZM86.02 29.13V19.8h-9.33v3.43c0 .37.31.67.7.67h3.67v2.77c-1.27.87-4.32 1.47-7.52 1.47-5.16 0-8.41-2.65-8.36-6.91.05-4.24 3.29-6.88 8.39-6.88 3.55 0 6.72.77 9.6 2.32l2.2-3.96c-6.02-2.86-11.27-2.69-11.81-2.69-7.92 0-13.45 4.61-13.45 11.2s5.28 11.23 13.14 11.23c8.5 0 12.76-3.33 12.76-3.33Z",
      class: "svg-A3-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "A3-logo"}) } }